import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const ActionButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.jigsaw.green,
    color: "black",
    borderRadius: "8px",
    minWidth: "100px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    "& img": {
      width: "20px",
      height: "20px",
    },
    "&:hover": {
      backgroundColor: "#A0C500",
    },
  }));